import ServicePage from "../Common/ServicePage";

// Water Purifier Repair & Maintenance specific services
const repairServices = [
  { 
    id: 1, 
    name: 'Basic Repair & Maintenance', 
    provider: 'AquaFix Professionals', 
    image: 'https://placehold.co/600x400?text=Basic+Repair', 
    rating: 4.78, 
    reviews: 800, 
    price: 400, 
    category: 'Basic Repair' 
  },
  { 
    id: 2, 
    name: 'Full Servicing & Part Replacement', 
    provider: 'WaterCare Experts', 
    image: 'https://placehold.co/600x400?text=Full+Servicing', 
    rating: 4.82, 
    reviews: 600, 
    price: 900, 
    category: 'Full Service' 
  },
  { 
    id: 3, 
    name: 'Leak Fix Service', 
    provider: 'LeakProof Solutions', 
    image: 'https://placehold.co/600x400?text=Leak+Fix', 
    rating: 4.75, 
    reviews: 450, 
    price: 150, 
    category: 'Leak Repair' 
  },
  { 
    id: 4, 
    name: 'Motor Replacement', 
    provider: 'MotorTech Specialists', 
    image: 'https://placehold.co/600x400?text=Motor+Replace', 
    rating: 4.80, 
    reviews: 350, 
    price: 500, 
    category: 'Part Replacement' 
  },
  { 
    id: 5, 
    name: 'UV Lamp Replacement', 
    provider: 'UV Care Professionals', 
    image: 'https://placehold.co/600x400?text=UV+Lamp', 
    rating: 4.85, 
    reviews: 300, 
    price: 300, 
    category: 'Part Replacement' 
  },
  { 
    id: 6, 
    name: 'Pump Repair Service', 
    provider: 'Pump Masters', 
    image: 'https://placehold.co/600x400?text=Pump+Repair', 
    rating: 4.79, 
    reviews: 400, 
    price: 350, 
    category: 'Pump Repair' 
  },
  { 
    id: 7, 
    name: 'Electrical Circuit Repair', 
    provider: 'ElectroWater Solutions', 
    image: 'https://placehold.co/600x400?text=Circuit+Repair', 
    rating: 4.83, 
    reviews: 250, 
    price: 200, 
    category: 'Electrical Repair' 
  },
  { 
    id: 8, 
    name: 'Annual Maintenance Contract', 
    provider: 'AquaGuard Services', 
    image: 'https://placehold.co/600x400?text=AMC', 
    rating: 4.88, 
    reviews: 900, 
    price: 1200, 
    category: 'Maintenance' 
  }
];

const repairCategories = ['Basic Repair', 'Full Service', 'Leak Repair', 'Part Replacement', 'Pump Repair', 'Electrical Repair', 'Maintenance'];

const packages = [
  { id: 1, title: "Basic Repair & Maintenance", rating: "4.78 (800 reviews)", price: 400, originalPrice: 500, icon: "build" },
  { id: 2, title: "Full Servicing & Part Replacement", rating: "4.82 (600 reviews)", price: 900, originalPrice: 1100, icon: "engineering" },
];

const miniServices = [
  { id: 101, title: "Leak Fix", price: 150, icon: "water_drop" },
  { id: 102, title: "Motor Replacement", price: 500, icon: "cable" },
];

export default function WaterPurifierRepair() {
  return (
    <ServicePage
      serviceName="Water Purifier Repair & Maintenance"
      packages={packages}
      miniServices={miniServices}
      customServices={repairServices}
      customCategories={repairCategories}
      isCustomService={true}
    />
  );
}